import * as Constants from "../../../consts/Constants.js";

import Api from "./api";
import auth from "../../auth/service";

const ADMIN_ROLE = 4501;

class ShifterService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(ADMIN_ROLE);
	}

}

export default new ShifterService(Constants.FINAL_URL_RESERVATIONS);